import pino from "pino"

const config = {
  formatters: {
    log: (obj: Record<string, unknown>) => {
      if (obj.error) {
        const error = obj.error
        const formattedError =
          error instanceof Error
            ? {
                message: error.message,
                // Limit stack trace to the first 5 lines for better readability
                stack_trace: error.stack
                  ? error.stack.split("\n").slice(0, 5).join("\n")
                  : undefined,
                name: error.name,
              }
            : {
                message:
                  error instanceof Object ? error : JSON.stringify(error),
                stack: undefined,
                name: "Error",
              }

        return {
          ...obj,
          error: formattedError,
        }
      }
      return obj
    },
  },
}

const GCP_FORMATTERS = {
  level: (label: string) => {
    return { severity: label.toUpperCase() }
  },
}

if (process.env.NODE_ENV !== "development") {
  config.formatters = {
    ...config.formatters,
    ...GCP_FORMATTERS,
  }
}

const logger = pino(config)

export default logger
